import { createColumnHelper } from '@tanstack/react-table';

import { Role } from '../types';

export const columnHelper = createColumnHelper<Role>();
